export default __webpack_public_path__ + "frontend/assets/kim-logo-transparent.png";